import React from 'react';
import { Play } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhoAreWe() {
  return <section id="about" className="py-20 lg:py-32 bg-white" data-id="element-167">
      <div className="container mx-auto px-4 md:px-6" data-id="element-168">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-169">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="relative group" data-id="element-170">
            <div className="aspect-video rounded-3xl overflow-hidden shadow-2xl relative bg-gray-100" data-id="element-171">
              <video src="https://cdn.magicpatterns.com/uploads/vd6wuSgQGYCoanzxPqbbj4/12526064_960_540_50fps.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" aria-label="Ambulances parked outside a medical facility" data-id="element-172" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-173">
            <h2 className="text-4xl md:text-5xl font-extrabold text-brand-blue mb-8" data-id="element-174">
              Who are we?
            </h2>
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-175">
              <p data-id="element-176">
                At CareBridge, we are on a mission to redefine the Inter
                Facility Transfer industry, offering our valued customers a
                comprehensive continuum of care.
              </p>
              <p data-id="element-177">
                Our commitment is underpinned by a set of core
                values—compassion, reliability, safety, and excellence—that
                guide us in serving our patients and community.
              </p>
              <p data-id="element-178">
                Beyond merely providing transportation, we believe in elevating
                the non-emergency medical transportation experience to something
                more profound.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}